import Badge from './Badge.vue';
import withInstall from '@/shared/withInstall';

export const XBadge = withInstall(Badge);
export default XBadge;
